import React from 'react'
import Standard from './Types/standard'
import DeepCleaning from './Types/deepCleaning'
import MoveInOutCleaning from './Types/moveInOut'

function ServiceTypes() {
  return (
        <div className="bg-gray-100 flex flex-col items-center py-10">
            <div className="mx-4 mb-6 max-w-screen-xl w-full rounded-lg bg-amber-50/80 border border-amber-200/80 px-4 py-3 text-center text-sm text-amber-900 shadow-sm">
                <p className="font-medium">Please note:</p>
                <p className="mt-1 text-amber-800">We do not clean any exterior areas or drywall in any of our cleaning services.</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mx-4 max-w-screen-xl">
                <div className="bg-white rounded-lg shadow-lg p-4 shadow-2xl"><Standard /></div>
                <div className="bg-white rounded-lg shadow-lg p-4 shadow-2xl"><DeepCleaning /></div>
                <div className="bg-white rounded-lg shadow-lg p-4 shadow-2xl"><MoveInOutCleaning /></div>
            </div>
        </div>
  )
}

export default ServiceTypes
